import { render, staticRenderFns } from "./GP2BrowserSettingsPanel.vue?vue&type=template&id=2362fa62&scoped=true&"
import script from "./GP2BrowserSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserSettingsPanel.vue?vue&type=style&index=0&id=2362fa62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362fa62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362fa62')) {
      api.createRecord('2362fa62', component.options)
    } else {
      api.reload('2362fa62', component.options)
    }
    module.hot.accept("./GP2BrowserSettingsPanel.vue?vue&type=template&id=2362fa62&scoped=true&", function () {
      api.rerender('2362fa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserSettingsPanel.vue"
export default component.exports